import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "3", y2: "17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "18 9 12 3 6 9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 21h14", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowUpFromLine";
const ArrowUpFromLine = memo(themed(Icon));
export {
  ArrowUpFromLine
};
//# sourceMappingURL=arrow-up-from-line.js.map
